
import {CompanySearch} from 'components/search-dropdown'

export default {
  components: {CompanySearch},
  emits: ['submit'],
  data() {
    return {
      user_id: undefined,
      chosen_company: undefined,
      comp_linkedin: undefined,
      loading: false,
    }
  },
  computed: {
    can_submit() {
      return !!this.chosen_company || !!this.comp_linkedin
    }
  },
  methods: {
    open(user_id){
      this.chosen_company = undefined
      this.comp_linkedin = undefined
      this.user_id = user_id
      this.loading = false
      this.$refs.modal.open()
    },
    close(force) {
      if (!force && this.loading) return
      this.$refs.modal.close()
      this.user_id = undefined
    },
    submit() {
      if (!this.chosen_company) {
        this.chosen_company = {
          linkedin_id: this.comp_linkedin
        }
      }

      this.loading = true
      this.$emit('submit', {
        chosen_company: this.chosen_company,
      })
    }
  }
}
